// @ts-nocheck
import React, { FunctionComponent } from 'react';
import { FieldProps, getIn } from 'formik';

// MUI
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import FormControlLabel, { FormControlLabelProps } from '@mui/material/FormControlLabel';
import Checkbox, { CheckboxProps } from '@mui/material/Checkbox';

// Properties
import * as styles from './FormCheckbox.styles';

const FormCheckbox: FunctionComponent<FieldProps & FormControlLabelProps & CheckboxProps> = props => {
    const { label, disabled, error, helperText, field, form, ...rest } = props;
    const isTouched = getIn(props.form.touched, props.field.name);
    const errorMessage = getIn(props.form.errors, props.field.name);

    return (
        <FormControl
            error={error ?? Boolean(isTouched && errorMessage)}
        >
            <FormControlLabel
                sx={styles.label}
                label={label}
                control={
                    <Checkbox
                        sx={styles.checkbox}
                        disabled={disabled ?? form.isSubmitting}
                        {...rest}
                        {...field}
                    />
                }
            />
            <FormHelperText
                sx={styles.helper}
            >
                {helperText ?? ((isTouched && errorMessage) ? errorMessage : undefined)}
            </FormHelperText>
        </FormControl>
    );
};

export default FormCheckbox;
